import React from "react";
import HeadingLabel from "../../../core/ui/components/HeadingLabel";
export interface Props {
  text: string;
  label: string;
}

const CaseLawDocumentSummary = ({ text, label }: Props) => {
  return (
    <>
      <div>
        <HeadingLabel text={label} />
      </div>
      <p>{text}</p>
    </>
  );
};

export default CaseLawDocumentSummary;
